import BigNumber from 'bignumber.js/bignumber'

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

export const ORI_PER_BLOCK = new BigNumber(3141592653589793238)
export const BLOCKS_PER_YEAR = new BigNumber(31536000)
export const BSC_BLOCK_TIME = 1
export const ORI_POOL_PID = 1
export const BASE_EXCHANGE_URL = 'https://ftm-swap.hyperjump.fi'
export const BASE_INFO_URL = 'https://ftm-info.hyperjump.fi'
export const BASE_INFO_PAIR_URL = `${BASE_INFO_URL}/pair`
export const BASE_ADD_LIQUIDITY_URL = `${BASE_EXCHANGE_URL}/#/add`
export const BASE_LIQUIDITY_POOL_URL = `${BASE_EXCHANGE_URL}/#/pool`
